import { GlobalRouterPath } from "./globalRoute";

const OnboardingRouterPath = {
  INTERESTED_WORK_TYPE: `${GlobalRouterPath.HOME}/interestedWorkType`,
  ONBOARDING_INFO1: `${GlobalRouterPath.HOME}/agentSignupInfo1`,
  ONBOARDING_INFO2: `${GlobalRouterPath.HOME}/agentSignupInfo2`,
  ONBOARDING_INFO3: `${GlobalRouterPath.HOME}/agentSignupInfo3`,
  ONBOARDING_ADDRESS: `${GlobalRouterPath.HOME}/agentAddress`,
  ONBOARDING_LICENSE: `${GlobalRouterPath.HOME}/agentLicense`,
  ONBOARDING_SKILL_ASSESSMENT: `${GlobalRouterPath.HOME}/skillAssessment`,
  ONBOARDING_PROCEED_TO_SKILL_ASSESSMENT: `${GlobalRouterPath.HOME}/proceedToSkillAssessment`,
  /**
   * @deprecated This route should not be used anymore, we are redirecting to agentLicense
   */
  ONBOARDING_QUALIFICATION: `${GlobalRouterPath.HOME}/agentQualification`,
  ONBOARDING_FIRST_NAME: `${GlobalRouterPath.HOME}/agentFirstName`,
  ONBOARDING_LAST_NAME: `${GlobalRouterPath.HOME}/agentLastName`,
  ONBOARDING_EMAIL: `${GlobalRouterPath.HOME}/agentEmail`,
  ONBOARDING_WELCOME: `${GlobalRouterPath.HOME}/welcomeAgent`,
  ONBOARDING_REVERIFY: `${GlobalRouterPath.HOME}/signupReVerify`,
  ONBOARDING_POTENTIAL_SHIFTS: `${GlobalRouterPath.HOME}/agentPotentialShifts`,
  ONBOARDING_CONTRACTOR_AGREEMENT_REVIEW: `${GlobalRouterPath.HOME}/contractAgreementReview`,
  ONBOARDING_CONTRACTOR_AGREEMENT: `${GlobalRouterPath.HOME}/contractAgreement`,
  ONBOARDING_STRIPE: `${GlobalRouterPath.HOME}/onboardToStripe`,
  READY_TO_EARN: `${GlobalRouterPath.HOME}/readyToEarn`,
  ONBOARDING_PROCEED_TO_REQUIREMENT_INFO: `${GlobalRouterPath.HOME}/requirementInfo`,
  ONBOARDING_UPLOAD_DOCUMENTS: `${GlobalRouterPath.HOME}/uploadDocuments`,
  ONBOARDING_SCHEDULED_ASSESSMENT_INSTRUCTIONS: `${GlobalRouterPath.HOME}/scheduledAssessmentInstructions`,
  ONBOARDING_SCHEDULED_ASSESSMENT: `${GlobalRouterPath.HOME}/scheduledAssessment`,
  ONBOARDING_SCHEDULED_ASSESSMENT_CONFIRMATION: `${GlobalRouterPath.HOME}/scheduledAssessmentConfirmation`,
  ONBOARDING_SSN: `${GlobalRouterPath.HOME}/agentSSN`,
  ONBOARDING_DOB: `${GlobalRouterPath.HOME}/agentDoB`,
  SHOW_FRIENDS_SHIFTS: `${GlobalRouterPath.HOME}/agentShowFriendsShifts`,
};

export { OnboardingRouterPath };
